export default __webpack_public_path__ + "static/1-cc99090f25b7d1cdf2bc333656c8ad46.webp";